import { Check, ShoppingBag } from "lucide-react";
import { useCart, isAccessory } from "@/lib/cart";

export const AddToCartButton = ({ p, forModel = "", onBlocked, testid }) => {
  const { add, has, setOpen } = useCart();
  const inCart = has(p, forModel);
  const device = !isAccessory(p);
  const onClick = () => {
    if (onBlocked && onBlocked()) return;
    if (inCart && device) setOpen(true);
    else add(p, forModel);
  };
  const label = !inCart ? "Adicionar ao carrinho" : device ? "No carrinho · ver carrinho" : "Adicionar mais um";
  return (
    <button type="button" data-testid={testid || `add-to-cart-${p.id}`} onClick={onClick}
      className="group/cart inline-flex w-full items-center justify-center gap-2 rounded-full border border-white/20 px-5 py-3 text-sm font-semibold text-white transition-colors duration-300 hover:border-white hover:bg-white hover:text-black active:scale-95">
      {inCart ? <Check className="h-4 w-4" /> : <ShoppingBag className="h-4 w-4 transition-transform duration-300 group-hover/cart:-translate-y-0.5" />}
      {label}
    </button>
  );
};
